<template>
  <div id="geo-info">
    <div id="location" class="cascading-dropdown">
      <div :id="parent + '-country'" class="dropdown mt-4">
        <label for="country" v-show="!search">Country:</label>
        <br />
        <b-form-select name="country" v-model="country" :state="countryInput">
          <option disabled>Select a Country</option>
          <option
            v-for="country in countries"
            :key="country"
            :value="country || ''"
          >
            {{ country }}
          </option>
        </b-form-select>
      </div>
      <div :id="parent + '-region'" class="dropdown mt-4">
        <label for="region" v-show="!search">Region:</label>
        <br />
        <b-form-select
          name="region"
          :disabled="regions.length == 0"
          v-model="region"
          :state="regionInput"
        >
          <option disabled>Select a Region</option>
          <option v-for="(region, i) in regions" :key="i">
            {{ region.option }}
          </option>
        </b-form-select>
      </div>
      <div :id="parent + '-district'" class="dropdown mt-4">
        <label for="district" v-show="!search">District:</label>
        <br />
        <b-form-select
          name="district"
          :disabled="districts.length == 0"
          v-model="district"
          :state="districtInput"
        >
          <option disabled>Select a District</option>
          <option v-for="(district, i) in districts" :key="i">
            {{ district.option }}
          </option>
        </b-form-select>
      </div>
      <div class="village mt-4" v-if="showVillage">
        <label for="village" v-show="!search">Village:</label>
        <b-form-input
          name="village"
          type="text"
          :id="parent + '-village'"
          v-model="village"
          placeholder="Add a village"
        ></b-form-input>
      </div>
      <div class="address mt-4" v-show="!search" v-if="showAddress">
        <label for="address">Address:</label>
        <b-form-input
          name="address"
          type="text"
          :id="parent + '-address'"
          v-model="address"
        ></b-form-input>
      </div>
      <!-- TODO: add map here to select coordinates-->
      <div v-show="coords" v-if="showCoords">
        <div class="latitude mt-4">
          <label for="latitude">Latitude:</label>
          <b-form-input
            name="latitude"
            type="text"
            :id="parent + '-latitude'"
            v-model="lat"
          ></b-form-input>
        </div>
        <div class="longitude mt-4">
          <label for="longitude">Longitude:</label>
          <b-form-input
            name="longitude"
            type="text"
            :id="parent + '-longitude'"
            v-model="lng"
          ></b-form-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "GeoInfo",
  props: {
    singular: String,
    plural: String,
    coords: Boolean,
    search: Boolean,
    parent: String,
  },
  data() {
    return {
      regions: [],
      districts: [],
      selectedCountry: "",
      selectedRegion: "",
      showVillage: this.parent != "group" && this.parent != "primary-school",
      showCoords: this.parent != "group",
      showAddress: this.parent != "group",
    };
  },
  methods: {
    ...mapActions({
      GET_OPTIONS: "optionsList/GET_OPTIONS",
    }),
    getRegions() {
      if (this.country && this.country.length > 0) {
        this.regions = [];
        this.optionsList.forEach((element) => {
          if (element.key == this.country + "Regions") {
            this.regionId = element.id;
            element.values.forEach((value) => {
              this.regions.push({
                id: element.values.indexOf(value),
                option: value,
              });
            });
          }
        });
      }
    },
    getDistricts() {
      if (this.region && this.region.length > 0) {
        this.districts = [];
        this.optionsList.forEach((element) => {
          if (element.key == this.country + this.region + "Districts") {
            this.districtId = element.id;
            element.values.forEach((value) => {
              this.districts.push({
                id: element.values.indexOf(value),
                option: value,
              });
            });
          }
        });
      }
    },
  },
  computed: {
    adminAreas: {
      get() {
        return this.$store.state.adminAreas;
      },
    },
    optionsList: {
      get() {
        return this.$store.state.optionsList.optionsList;
      },
    },
    countries: {
      get() {
        return this.$store.state.optionsList.countries;
      },
    },
    country: {
      get() {
        return this.$store.state[this.plural][this.singular].country;
      },
      set(val) {
        this.$store.commit(`${this.plural}/country`, val);
      },
    },
    region: {
      get() {
        return this.$store.state[this.plural][this.singular].region;
      },
      set(val) {
        this.$store.commit(`${this.plural}/region`, val);
      },
    },
    district: {
      get() {
        return this.$store.state[this.plural][this.singular].district;
      },
      set(val) {
        this.$store.commit(`${this.plural}/district`, val);
      },
    },
    village: {
      get() {
        return this.$store.state[this.plural][this.singular].village;
      },
      set(val) {
        this.$store.commit(`${this.plural}/village`, val);
      },
    },
    address: {
      get() {
        return this.$store.state[this.plural][this.singular].address;
      },
      set(val) {
        this.$store.commit(`${this.plural}/village`, val);
      },
    },
    lat: {
      get() {
        if (!this.coords) {
          return 0;
        }
        return this.$store.state[this.plural][this.singular].lat;
      },
      set(val) {
        if (!this.coords) {
          return null;
        }
        this.$store.commit(`${this.plural}/lat`);
      },
    },
    lng: {
      get() {
        if (!this.coords) {
          return null;
        }
        return this.$store.state[this.plural][this.singular].lng;
      },
      set(val) {
        if (!this.coords) {
        } else {
          this.$store.commit(`${this.plural}/lng`);
        }
      },
    },
    countryInput() {
      if (
        this.$store.state[this.plural][this.singular].country &&
        this.$store.state[this.plural][this.singular].country.length > 3 &&
        this.$store.state[this.plural][this.singular].country !== null
      )
        return true;
      else return false;
    },
    regionInput() {
      if (
        this.$store.state[this.plural][this.singular].region &&
        this.$store.state[this.plural][this.singular].region.length > 3 &&
        this.$store.state[this.plural][this.singular].region !== null
      )
        return true;
      else return false;
    },
    districtInput() {
      if (
        this.$store.state[this.plural][this.singular].district &&
        this.$store.state[this.plural][this.singular].district.length > 3 &&
        this.$store.state[this.plural][this.singular].district !== null
      )
        return true;
      else return false;
    },
    edit() {
      return !this.$route.path.includes("/add");
    },
  },
  watch: {
    country() {
      // Clear previously selected values
      this.regions = [];
      this.districts = [];
      this.getRegions();
    },
    region() {
      // Clear previously selected values
      this.districts = [];
      this.getDistricts();
    },
  },
  created() {
    this.getRegions();
    this.getDistricts();
  },
  async mounted() {
    await this.GET_OPTIONS();
  },
};
</script>

<style scoped>
.location-underline {
  text-decoration: underline;
}
</style>
